// Import Libraries
import React from 'react';
// Import JS Modules
import Spinner from '../../../../_utils/spinner';

const PendingPhoto = () => (
  <div className="photo pending">
    <Spinner />
  </div>
);

export default PendingPhoto;
